import { useQuery } from '@tanstack/react-query';

import { Workspaces } from '@air/api';
import { ONE_DAY } from '@air/utilities';

import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { canSeePrivateWorkspaceDetails } from '~/utils/permissions/workspacePermissions';

export const WORKSPACES_TOTALS = 'WORKSPACES_TOTALS';

export const getWorkspaceTotalsKey = (workspaceId?: string) => {
  return workspaceId ? [WORKSPACES_TOTALS, { workspaceId }] : [WORKSPACES_TOTALS];
};

/** This hook returns the totals (total assets, bytes used, and members) for the workspace */
export const useWorkspaceTotals = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;
  const { data: permissions } = useCurrentWorkspacePermissionsContext();

  return useQuery({
    queryKey: getWorkspaceTotalsKey(workspaceId),

    queryFn: () => {
      if (!workspaceId) {
        throw new Error('No workspace id');
      }

      return Workspaces.totals({ workspaceId });
    },
    staleTime: ONE_DAY,
    enabled: !!workspaceId && canSeePrivateWorkspaceDetails(permissions),
  });
};
